import styled from '@emotion/styled';

export default styled.section`
    .layout-container {
        .section-articles {
            padding: 4em 0;
        }
    }
`;
